module.exports = __webpack_public_path__ + "static/media/logo2.a074ccc6.png";